<div
  class="row item pointer-cursor pt-3 pb-1 px-2"
  [ngClass]="{ 'active-item': id === sharedData.selectedBuilding.buildingId }"
  (click)="buildingClickHandler(id, name)"
>
  <div class="col-2 text-center">
    <img src="assets/svg/ico-building-with-black-circle.svg" class="icon" />
  </div>
  <div class="col-7 heading">
    <app-with-tooltip [showHelpCursor]="true">{{ name }}</app-with-tooltip>
  </div>
  <div class="col-3 pr-4 text-right setting-icon">
    <img src="assets/svg/ico-chevron-forward-outline.svg" />
  </div>
</div>
